import { Title, Subtitle } from 'components/DesktopTable/Empty/styles';
import React from 'react';

const UsersNotFound = () => {
  return (
    <>
      <Title>No results found</Title>
      <Subtitle>Sorry, there is no user that fits with your search.</Subtitle>
    </>
  );
};

export default UsersNotFound;
